var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9479 10L13.8052 12.858C14.0649 13.1179 14.0649 13.5453 13.8052 13.8051C13.5454 14.065 13.1181 14.065 12.8583 13.8051L10.001 10.9471L7.14376 13.8051C6.884 14.065 6.45666 14.065 6.19691 13.8051C6.06703 13.6752 6 13.5034 6 13.3316C6 13.1598 6.06703 12.988 6.19691 12.858L9.0542 10L6.19691 7.14196C6.06703 7.01205 6 6.84023 6 6.66841C6 6.49659 6.06703 6.32478 6.19691 6.19487C6.45666 5.93504 6.884 5.93504 7.14376 6.19487L10.001 9.05291L12.8583 6.19487C13.1181 5.93504 13.5454 5.93504 13.8052 6.19487C14.0649 6.45469 14.0649 6.88214 13.8052 7.14196L10.9479 10Z",
    fill: "#1B365B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.6,
    stroke: "#1B365B",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.8c657de50cde8f58c7eb63d1af01175e.svg";
export { ForwardRef as ReactComponent };